import { useContext } from 'react';

import type { ShiftContextValue } from '../../../types';
import ShiftContext from './ShiftContext';

const useShiftContext = (): ShiftContextValue => {
  const context = useContext(ShiftContext);

  if (!context) {
    throw new Error('useShiftContext must be used within a ShiftProvider');
  }

  return context;
};

export default useShiftContext;
